module.exports = __webpack_public_path__ + "img/xx.30e54fd1.svg";